/*********************************************************************
 * 
 * WARNING: This shader class is automatically generated, any manual 
 * edits will be lost.
 * Last generated: 2020-04-03T14:33:08.690Z
 * 
 ********************************************************************/
import { ShaderBase } from '../ShaderBase';

export type CompositeShaderUniforms = {
	uModelViewMatrix: WebGLUniformLocation,
	uViewMatrix: WebGLUniformLocation,
	uProjectionMatrix: WebGLUniformLocation,
	uBoneMatrix: WebGLUniformLocation,
	uOffsetMatrix: WebGLUniformLocation,
	uModelViewInverseTransposeMatrix: WebGLUniformLocation,
	uPointLightingLocation: WebGLUniformLocation[],
	uPointLightingColor: WebGLUniformLocation[],
	uCameraWorldPosition: WebGLUniformLocation,
	uLightCount: WebGLUniformLocation,
	uTextureSampler: WebGLUniformLocation,
	uBindShapeMatrix: WebGLUniformLocation,
	uInvBindShapeMatrix: WebGLUniformLocation,
	uMatrixSampler: WebGLUniformLocation,
	uDataSettings: WebGLUniformLocation,
	uPresetColor: WebGLUniformLocation,
	uPickingColor: WebGLUniformLocation,
	uShininess: WebGLUniformLocation,
	uAmbientColor: WebGLUniformLocation
};

export type CompositeShaderAttributes = {
	aVertexPosition: number,
	aVertexNormal: number,
	aVertexColor: number,
	aVertexLight: number,
	aTextureCoord: number,
	aJointWeights: number,
	aJointIndices: number
};

export type CompositeShaderSettings = ('ATTACHMENT' | 'PICKING' | 'DYNAMIC_LIGHT' | 'ATTRIBUTE_COLOR' | 'ATTRIBUTE_LIGHT' | 'TEXTURE' | 'ANIMATION' | 'PRESET_COLOR' | 'DYNAMIC_LIGHTNING')[];

export class CompositeShader extends ShaderBase<CompositeShaderUniforms, CompositeShaderAttributes> {

    private static fragmentShaderSource = `
uniform mat4 uModelViewMatrix;
uniform mat4 uViewMatrix;

#ifdef SPI_PICKING
uniform vec4 uPickingColor;
#else
uniform mat4 uModelViewInverseTransposeMatrix;
varying vec3 vTransformedNormal;
varying vec4 vPosition;
varying vec4 vColor;
#ifdef SPI_ATTRIBUTE_LIGHT
varying vec3 vVertexLight;
#endif
#endif

#ifdef SPI_TEXTURE
varying vec2 vTextureCoord;
uniform sampler2D uTextureSampler;
#endif

#ifdef SPI_PRESET_COLOR
uniform vec4 uPresetColor;
#endif

#ifndef SPI_PICKING
#ifdef SPI_DYNAMIC_LIGHTNING
uniform float uShininess;
varying vec3 vSurfaceToLight[8];
varying vec3 vSurfaceToView[8];
uniform vec3 uAmbientColor;
uniform vec4 uPointLightingLocation[8];
// use the alpha channel for attenuation (light falloff over distance)
uniform vec4 uPointLightingColor[8];
uniform int uLightCount;

#endif
#endif

#ifdef SPI_DYNAMIC_LIGHTNING
vec3 apply_dynamic_lightning() {

	vec3 normal = normalize(vTransformedNormal);
	vec3 lightWeighting = uAmbientColor; 

	for(int i = 0; i < 8; i++) {

		if(i == uLightCount) break;

		//vec3 surfaceToLightDirection = normalize(vSurfaceToLight[i]);
  		//vec3 surfaceToViewDirection = normalize(vSurfaceToView[i]);
  		//vec3 halfVector = normalize(surfaceToLightDirection + surfaceToViewDirection);

		//float light = dot(normal, surfaceToLightDirection);

		vec3 lightLocation = (uViewMatrix * vec4(uPointLightingLocation[i].xyz, 1.0)).xyz;
		vec3 lightDirection = normalize(lightLocation - vPosition.xyz);

		//vec3 lightDirection = surfaceToLightDirection;

		float directionalLightWeighting = max(dot(normal, lightDirection), 0.0);
		//float directionalLightWeighting = max(dot(normal, lightDirection), 0.0);

		// float specular = 0.0;
		// if (light > 0.0) {
		// 	specular = pow(dot(normal, halfVector), uShininess);
		// }

		float distanceToLight = length(lightLocation - vPosition.xyz);

		//if(distanceToLight < 15.0) {
			float attenuation = 1.0 / (1.0 + uPointLightingColor[i].a * pow(distanceToLight, 2.0));

			lightWeighting += attenuation * directionalLightWeighting * uPointLightingColor[i].rgb;
		//}

		//vec3 lightLocation = (uLightMatrix * vec4(uPointLightingLocation[i].xyz, 1.0)).xyz;
		
		//float distanceToLight = length(lightLocation - vPosition.xyz);
		//float attenuation = 1.0 / (1.0 + uPointLightingColor[i].a * pow(distanceToLight, 2.0));
		
		//vec3 lightDirection = normalize(lightLocation - vPosition.xyz);
		//float directionalLightWeighting = max(dot(normal, lightDirection), 0.0);
		//lightWeighting += attenuation * (uPointLightingColor[i].xyz * directionalLightWeighting); 
	
    }

	//vec3 gamma = vec3(1.0 / 2.2);
	//color = pow(lightWeighting, gamma);

	return lightWeighting;
}
#endif


void main(void) {
	vec3 color = vec3(1);

#ifdef SPI_PICKING
	gl_FragColor = uPickingColor;
#else
	
#ifdef SPI_DYNAMIC_LIGHTNING
	color = apply_dynamic_lightning();
#else

#ifdef SPI_ATTRIBUTE_LIGHT
	color = vVertexLight;
#else

#ifdef SPI_PRESET_COLOR
	color = uPresetColor.rgb;
#endif

#endif

#endif

#ifdef SPI_ATTRIBUTE_COLOR
	gl_FragColor = vec4(vColor.rgb * color, vColor.a);
#else
#ifdef SPI_TEXTURE	
	vec4 textureColor = texture2D(uTextureSampler, vTextureCoord);
	gl_FragColor = vec4(textureColor.rgb * color, textureColor.a);
#else
	gl_FragColor = vec4(color, 1.0);
#endif
#endif



#endif
}
`;

    private static vertexShaderSource = `
uniform mat4 uModelViewMatrix;
uniform mat4 uViewMatrix;
uniform mat4 uProjectionMatrix;

varying vec3 vSurfaceToLight[8];
varying vec3 vSurfaceToView[8];

attribute vec3 aVertexPosition;
varying vec4 vPosition;

#ifdef SPI_ATTACHMENT
uniform mat4 uBoneMatrix;
uniform mat4 uOffsetMatrix;
#endif

#ifndef SPI_PICKING
attribute vec3 aVertexNormal;
uniform mat4 uModelViewInverseTransposeMatrix;
varying vec3 vTransformedNormal;

#ifdef SPI_DYNAMIC_LIGHT

uniform vec4 uPointLightingLocation[8];
// use the alpha channel for attenuation (light falloff over distance)
uniform vec4 uPointLightingColor[8];
uniform vec3 uCameraWorldPosition;
uniform int uLightCount;
#endif

#endif

#ifdef SPI_ATTRIBUTE_COLOR
attribute vec4 aVertexColor;
varying vec4 vColor;
#endif

#ifdef SPI_ATTRIBUTE_LIGHT
attribute vec3 aVertexLight;
varying vec3 vVertexLight;
#endif

#ifdef SPI_TEXTURE
#ifndef SPI_PICKING
attribute vec2 aTextureCoord;
varying vec2 vTextureCoord;
uniform sampler2D uTextureSampler;
#endif
#endif

#ifdef SPI_ANIMATION
attribute vec4 aJointWeights;
attribute vec4 aJointIndices;

uniform mat4 uBindShapeMatrix;
uniform mat4 uInvBindShapeMatrix;
uniform sampler2D uMatrixSampler;
uniform vec3 uDataSettings;
#endif


#ifdef SPI_PRESET_COLOR
uniform vec4 uPresetColor;
#endif


#ifdef SPI_ANIMATION
mat4 read_matrix (sampler2D tex, float i, vec2 size) {
  // Apply an offset so that the coordinate targets the center of the texel, otherwise the wrong texel might be read causing incorrect matrices
  const float offset = 0.5; 
  float tx = mod(i * 4.0, size.x) + offset;
  float ty = floor(i * 4.0 / size.x) + offset;
  
  return mat4(
    texture2D(tex, vec2((tx + 0.0) / size.x, ty / size.y)),
    texture2D(tex, vec2((tx + 1.0) / size.x, ty / size.y)),
    texture2D(tex, vec2((tx + 2.0) / size.x, ty / size.y)),
    texture2D(tex, vec2((tx + 3.0) / size.x, ty / size.y))
  );
}

mat4 read_animation() {
	mat4 matrix = mat4(0.0);

	for(int j = 0; j < 4; j++) {
		if(int(aJointIndices[j]) == -1) break;

		float index = aJointIndices[j] + uDataSettings.z;
		mat4 jointMatrix = read_matrix(uMatrixSampler, index, uDataSettings.xy);

		matrix += jointMatrix * aJointWeights[j]; 
	}
	return matrix;
}

#endif

void main(void) {

#ifndef SPI_PICKING
	mat4 invMat = uModelViewInverseTransposeMatrix;
#endif

#ifdef SPI_ANIMATION
	mat4 posMat = read_animation();
	vec4 pos = vec4(aVertexPosition, 1.0) * uBindShapeMatrix * posMat;
#ifndef SPI_PICKING
	vec4 normal = vec4(aVertexNormal, 0.0) * uBindShapeMatrix * posMat;
#endif

#else
	vec4 pos = vec4(aVertexPosition, 1.0);
#ifndef SPI_PICKING
	vec4 normal = vec4(aVertexNormal, 0.0);
#endif
#endif

#ifdef SPI_ATTRIBUTE_COLOR
#ifdef SPI_PRESET_COLOR
	vColor = aVertexColor * uPresetColor;
#else
	vColor = aVertexColor;
#endif
#endif

#ifdef SPI_ATTRIBUTE_LIGHT
	vVertexLight = aVertexLight;
#endif

#ifdef SPI_ATTACHMENT
	pos = pos * uBoneMatrix;
#endif

	vPosition = uModelViewMatrix * vec4(pos.xyz, 1.0);
	gl_Position = uProjectionMatrix * vPosition;
#ifndef SPI_PICKING

#ifdef SPI_DYNAMIC_LIGHT

	for(int i = 0; i < 8; i++) {
		if(i == uLightCount) break;

		vSurfaceToLight[i] = (uViewMatrix * vec4(uPointLightingLocation[i].xyz, 1.0)).xyz - vPosition.xyz;
		vSurfaceToView[i] = normalize(uCameraWorldPosition - vPosition.xyz);
	}
#endif

#ifdef SPI_ATTACHMENT
	normal = normal * uBoneMatrix;
#endif
	vTransformedNormal = mat3(invMat) * normal.xyz; 
	
#ifdef SPI_TEXTURE
	vTextureCoord = aTextureCoord;
#endif
#endif
}
`;

    protected get warnAttributeMismatch(): boolean {
        return false;
    }
    constructor(gl: WebGLRenderingContext, settings: CompositeShaderSettings) {
        super(gl, CompositeShader.fragmentShaderSource, CompositeShader.vertexShaderSource, settings);
    }

}
        